import { ReactEventHandler } from 'react';
import { useIntl } from 'react-intl';

import { DownloadIcon } from '@dynatrace/strato-icons';

import { HorizontalDivider } from './divider.js';
import type { IntentProps } from '../../../../../core/slots/Intent/Intent.js';
import { Menu } from '../../../../../navigation/menu/Menu.js';
import { TOOLBAR_MESSAGES } from '../messages.js';

type IntentsCollapsedSectionProps = {
  hidden: boolean;
  intents?: Array<IntentProps>;
  showDownloadButton: boolean;
  handleDownloadDataToolbar?: () => void;
};

export const IntentsCollapsedAndDownloadSection = (
  props: IntentsCollapsedSectionProps,
) => {
  const intl = useIntl();

  if (props.hidden) {
    return null;
  }
  const { intents, showDownloadButton, handleDownloadDataToolbar } = props;

  if (intents?.length === 1 && !showDownloadButton) {
    const intent = intents[0];
    return [
      <HorizontalDivider key="br" />,
      <Menu.Intent {...intent} key="intent">
        {intent.icon && <Menu.Prefix>{intent.icon}</Menu.Prefix>}
        {intent.children}
      </Menu.Intent>,
    ];
  }

  const shouldShowDownloadCSV = showDownloadButton && handleDownloadDataToolbar;
  const shownIntents = intents ?? [];
  const renderDownloadItem = (handleClick: ReactEventHandler) => (
    <Menu.Item onSelect={handleClick} key="downloadBtn">
      <Menu.Prefix>
        <DownloadIcon />
      </Menu.Prefix>
      {intl.formatMessage(TOOLBAR_MESSAGES.downloadDataButton)}
    </Menu.Item>
  );

  const renderIntentsSection = () => (
    <Menu.Sub key="IntentsCollapsedSection">
      <Menu.SubTrigger>
        {intl.formatMessage(TOOLBAR_MESSAGES.moreOptions)}
      </Menu.SubTrigger>
      <Menu.SubContent>
        {shouldShowDownloadCSV && renderDownloadItem(handleDownloadDataToolbar)}
        {shouldShowDownloadCSV && shownIntents.length > 0 && (
          <HorizontalDivider key="br" />
        )}
        {shownIntents.map((item) => (
          <Menu.Intent {...item} key={item.children?.toString()}>
            {item.icon && <Menu.Prefix>{item.icon}</Menu.Prefix>}
            {item.children}
          </Menu.Intent>
        ))}
      </Menu.SubContent>
    </Menu.Sub>
  );

  if (shownIntents.length > 0) {
    return [<HorizontalDivider key="br" />, renderIntentsSection()];
  } else if (shouldShowDownloadCSV) {
    return [
      <HorizontalDivider key="br" />,
      renderDownloadItem(handleDownloadDataToolbar),
    ];
  } else {
    return null;
  }
};
